export default "__VITE_ASSET__CYZQylJt__ 640w, __VITE_ASSET__BwJqfQAn__ 1024w, __VITE_ASSET__CHHGT03x__ 1920w";